import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { Label } from '../../../ui/label';
import CustomSelect from '../../../ui/CustomSelect';

interface BusinessProfileSectionProps {
  businessProfile: string;
  economicSector: string;
  onChange: (field: string, value: string) => void;
}

export default function BusinessProfileSection({
  businessProfile,
  economicSector,
  onChange,
}: BusinessProfileSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Profil Usaha / Pekerjaan dan Kebutuhan Pinjaman</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Profil Calon Debitur</Label>
            <textarea
              value={businessProfile || ''}
              onChange={e => onChange('business_profile', e.target.value)}
              rows={3}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
              placeholder="Debitur merupakan satu dari tiga penjual sembako di pasar Wiyung, kecamatan Wiyung, kota Surabaya"
            />
          </div>
          <div className="space-y-2">
            <Label>Sektor Ekonomi</Label>
            <CustomSelect
              value={economicSector || ''}
              onChange={v => onChange('economic_sector', v)}
              placeholder="Pilih Sektor Ekonomi"
              width="w-full"
              color="blue"
              options={[
                { value: 'PERDAGANGAN BESAR ALAS KAKI', label: 'PERDAGANGAN BESAR ALAS KAKI' },
                { value: 'PERDAGANGAN ECERAN', label: 'PERDAGANGAN ECERAN' },
                { value: 'JASA', label: 'JASA' },
                { value: 'INDUSTRI', label: 'INDUSTRI' },
                { value: 'PERTANIAN', label: 'PERTANIAN' },
              ]}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
